import React from 'react';

import GenericComponent from 'components/utility/GenericComponent/GenericComponent';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import {
  FakeControls,
  FakeDropdown,
  FakeTab,
  FakeTabsBlock,
} from 'components/base/SkeletonLoader/FakeInteractive';
import Table from 'components/data-visualization/Table/Table';
import Body from 'components/data-visualization/Table/Body';
import { BrowseEntityItems } from 'components/data-containers/BrowseEntities/SkeletonLoader';

type TOption = { label: string; value: string };

interface IOptions {
  initialTab: TOption;
  isLargeScreen: boolean;
  title: string;
  toggleOptions: TOption[];
}

const SkeletonLoader: React.FC<IOptions> = (props) => {
  const { initialTab, isLargeScreen, title, toggleOptions } = props;

  return (
    <GenericComponent
      title={title}
      loading
      showToolbarDropdown={false}
      allowedFilters={[]}
      isWide
    >
      <AnimatedLoadingWrapper loading={true} browseRelated>
        {isLargeScreen ? (
          <FakeControls browseRelated>
            <FakeTabsBlock>
              {toggleOptions.map((option: any) => (
                <FakeTab key={option.value} active={option.value === 'Spotify'}>
                  {option.label}
                </FakeTab>
              ))}
            </FakeTabsBlock>
          </FakeControls>
        ) : (
          <FakeDropdown active>{initialTab?.value}</FakeDropdown>
        )}
        <Table>
          <Body>
            <BrowseEntityItems />
          </Body>
        </Table>
      </AnimatedLoadingWrapper>
    </GenericComponent>
  );
};

export default SkeletonLoader;
